import React from 'react';
import styled from "@emotion/styled";
import HeaderBlock from "../components/header/HeaderBlock";
import SideDrawerContainer from "../components/sideDrawer/SideDrawerContainer";


const Content = styled.div`
  width: 100vw;
  height: 100vh;
`;


const MainBlock = styled.div`  
    display: grid;
    height: 100%;
    grid-template-columns: var(--side-nav-width) auto;
`;

function ContentWrapper(props) {
    return (
        <Content>
            <HeaderBlock />
            <MainBlock>
                <SideDrawerContainer/>
                {props.children}
            </MainBlock>

        </Content>
    );
}

ContentWrapper.propTypes = {};
ContentWrapper.defaultProps = {};

export default ContentWrapper;
